import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ExtraBedsStoreEffects } from './effects';
import { featureReducer } from './reducer';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('extraBeds', featureReducer),
    EffectsModule.forFeature([ExtraBedsStoreEffects]),
  ],
})
export class ExtraBedsStoreModule {}
